import React from 'react';

import RichText from '~/src/common/components/CMS/RichText';

import * as S from './layout';

interface Props {
  content: string;
  title: string;
}

const ProductGenericInformation = ({ content, title }: Props) => {
  return (
    <S.Container>
      <S.Header id="product-information">{title}</S.Header>
      <S.Description>
        <RichText html={content} />
      </S.Description>
    </S.Container>
  );
};

export default ProductGenericInformation;
